/**
 * Stage 1b list order (Odin 2026-10-30): newest fake first, by the time each
 * was made (regenerated_at, else created_at, the "made" time shown on the row).
 * Each fake keeps its number, its place in the stored candidate list, so
 * FAKE 18 stays FAKE 18 and the judge's notes still match. Ties (one batch
 * made at once) and fakes with no time put the higher number first; a fake
 * with no time sorts after every timed one.
 */
export interface MadeAt {
  created_at: string | null;
  regenerated_at?: string | null;
}

export function newestFirst<T extends MadeAt>(candidates: T[]): { c: T; n: number }[] {
  const made = (c: T) => {
    const t = Date.parse(c.regenerated_at || c.created_at || '');
    return Number.isNaN(t) ? -Infinity : t;
  };
  return candidates
    .map((c, i) => ({ c, n: i + 1, t: made(c) }))
    .sort((a, b) => (b.t === a.t ? b.n - a.n : b.t > a.t ? 1 : -1))
    .map(({ c, n }) => ({ c, n }));
}
